"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createSvg = require("../createSvg");
var _interfaces = require("../interfaces");
var _SVGIconWithSizes;
var _default = (0, _createSvg.createSvg)('IconItalic', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M7.15056 1C7.15056 1 6.96056 1.49 6.92056 1.67C6.88056 1.85 6.92056 2.14 7.07056 2.19C7.22056 2.23 8.15056 2.43 8.15056 2.43L6.39056 13.48C5.78056 13.68 5.01056 14.15 5.01056 14.15L4.82056 15H8.88056C8.88056 15 9.07056 14.51 9.11056 14.33C9.15056 14.15 9.11056 13.86 8.96056 13.81C8.81056 13.77 7.88056 13.57 7.88056 13.57H7.83056L9.64056 2.52C10.2506 2.33 11.0206 1.85 11.0206 1.85L11.2106 1H7.15056Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M8.9384 1.00391C8.9384 1.00391 8.7009 1.61641 8.6509 1.84141C8.6009 2.06641 8.6509 2.42891 8.8384 2.49141C9.0259 2.54141 10.1884 2.79141 10.1884 2.79141L7.98838 17.1C7.22588 17.35 6.26338 17.9375 6.26338 17.9375L6.02588 19H11.1009C11.1009 19 11.3384 18.3875 11.3884 18.1625C11.4384 17.9375 11.3884 17.575 11.2009 17.5125C11.0134 17.4625 9.85088 17.2125 9.85088 17.2125H9.78838L12.0509 2.90391C12.8134 2.66641 13.7759 2.06641 13.7759 2.06641L14.0134 1.00391H8.9384Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M10.726 1.00781C10.726 1.00781 10.441 1.74281 10.381 2.01281C10.321 2.28281 10.381 2.71781 10.606 2.79281C10.831 2.85281 12.226 3.15281 12.226 3.15281L9.58596 20.72C8.67096 21.02 7.51596 21.725 7.51596 21.725L7.23096 23H13.321C13.321 23 13.606 22.265 13.666 21.995C13.726 21.725 13.666 21.29 13.441 21.215C13.216 21.155 11.821 20.855 11.821 20.855H11.746L14.461 3.28781C15.376 3.00281 16.531 2.28281 16.531 2.28281L16.816 1.00781H10.726Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M14.3012 1.00781C14.3012 1.00781 13.9212 1.98781 13.8412 2.34781C13.7612 2.70781 13.8412 3.28781 14.1412 3.38781C14.4412 3.46781 16.3012 3.86781 16.3012 3.86781L12.7811 27.96C11.5611 28.36 10.0211 29.3 10.0211 29.3L9.64111 31H17.7611C17.7611 31 18.1411 30.02 18.2211 29.66C18.3011 29.3 18.2211 28.72 17.9211 28.62C17.6211 28.54 15.7611 28.14 15.7611 28.14H15.6611L19.2812 4.04781C20.5012 3.66781 22.0412 2.70781 22.0412 2.70781L22.4212 1.00781H14.3012Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));
exports.default = _default;